import React from 'react';
import { Box, Chip, Container, Table, TableBody, TableCell, TableContainer, TableRow } from '@mui/material'
import { MedicalPaperRequest, MedicalPaperRequestStatus } from '../../../types/MedicalPaperRequest';
import { DateTime } from 'luxon';
import { RunCircleRounded, MopedRounded, CheckCircleRounded, CancelRounded, FiberNewRounded } from '@mui/icons-material';

const getIconFromStatus = (status: MedicalPaperRequestStatus) => {
  if (status === 'Processing') return <RunCircleRounded />;
  else if (status === 'Available') return <MopedRounded />;
  else if (status === 'Completed') return <CheckCircleRounded />;
  else if (status === 'Cancelled') return <CancelRounded />;
  return <FiberNewRounded />;
};

const getColorFromStatus = (status: MedicalPaperRequestStatus) => {
  if (status === 'Processing') return 'warning';
  else if (status === 'Available') return 'secondary';
  else if (status === 'Completed') return 'success';
  else if (status === 'Cancelled') return 'error';
  return 'info';
};

type Props = {
  medicalPaperRequest: MedicalPaperRequest
}
export const MedicalPaperRequestInfoBox = (props: Props) => {
  const { medicalPaperRequest } = props;

  return (
    <Container disableGutters>
      <Box>
        <TableContainer>
          <Table size="small">
            <TableBody>
              <TableRow>
                <TableCell width={250}>Id Number</TableCell>
                <TableCell>{medicalPaperRequest.idNumber}</TableCell>
              </TableRow>
              <TableRow>
                <TableCell width={250}>Name</TableCell>
                <TableCell>{medicalPaperRequest.name}</TableCell>
              </TableRow>
              <TableRow>
                <TableCell width={250}>Clinic</TableCell>
                <TableCell>{medicalPaperRequest.clinic === 'OTHERS' && medicalPaperRequest.others ? medicalPaperRequest.others.toUpperCase() : medicalPaperRequest.clinic}</TableCell>
              </TableRow>
              <TableRow>
                <TableCell width={250}>Date</TableCell>
                <TableCell>{medicalPaperRequest.date ? DateTime.fromISO(medicalPaperRequest.date).toFormat('MMMM dd, yyyy') : ''}</TableCell>
              </TableRow>
              <TableRow>
                <TableCell width={250}>Date Requested</TableCell>
                <TableCell>{DateTime.fromISO(medicalPaperRequest.dateRequested).toFormat('MMMM dd, yyyy — hh:mm:ss a')}</TableCell>
              </TableRow>
              <TableRow sx={{
                '&:last-child td, &:last-child th': { border: 0 } 
              }}>
                <TableCell width={250}>Status</TableCell>
                <TableCell>
                  <Chip 
                    icon={getIconFromStatus(medicalPaperRequest.status)} 
                    label={medicalPaperRequest.status} 
                    color={getColorFromStatus(medicalPaperRequest.status)}
                    variant="outlined" />
                  </TableCell>
              </TableRow>
            </TableBody>
          </Table>
        </TableContainer>
      </Box>
    </Container>
  );
};
